// extracted by mini-css-extract-plugin
export default {"root":"uo26K","skeleton-progress":"xHaQR"};